import {
    Button,
    DateRangeField,
    Form,
    FormFooter,
    FormSection,
    Page,
    toast
} from '@7shifts/sous-chef';
import { getLeadsAwaitingWorkingReport } from 'api/reportsApi';
import { useFormik } from 'formik';
import { __ } from 'i18n/translate';
import { downloadCSV } from 'utils/csv';
import { dateYearMonthDay } from 'utils/date';

type FormData = {
    date: { start: Date; end: Date };
};

const LeadsAwaitingWorkingPage = () => {
    const formik = useFormik<FormData>({
        initialValues: {
            date: {
                start: new Date(),
                end: new Date()
            }
        },
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            getLeadsAwaitingWorkingReport(
                dateYearMonthDay(values.date.start),
                dateYearMonthDay(values.date.end)
            )
                .then((data) => {
                    downloadCSV(data, 'leads-average-awaiting-working.csv');
                })
                .catch(() => {
                    toast('Something went wrong', 'danger');
                })
                .finally(() => formik.setSubmitting(false));
        }
    });

    return (
        <Page
            breadcrumbs={__('main.reports')}
            title={__('reportsPage.reportLeadsAwaitingWorking')}
            subtitle={__('reportsPage.reportLeadsAwaitingWorkingDescription')}
        >
            <Form formik={formik}>
                <FormSection as="card">
                    <DateRangeField
                        name="date"
                        label="Período"
                        format="dd/MM/yyyy"
                    />
                </FormSection>
                <FormFooter
                    actions={{
                        primary: (
                            <Button type="submit" loading={formik.isSubmitting}>
                                {__('main.downloadCSV')}
                            </Button>
                        )
                    }}
                />
            </Form>
        </Page>
    );
};

export default LeadsAwaitingWorkingPage;
